/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Dispatch, AnyAction } from 'redux';
import { AxiosError } from 'axios';
import { NotificationItem } from '../components/common/Notifications/NotificationItem';

export enum PageActionType {
  ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
}

export interface PageAction extends AnyAction {
  type: PageActionType;
  payload: NotificationItem.PropsWithoutId[] | string;
}

// For error, use addErrorNotification() so that the full stack trace is logged
export const addNotifications = (notifications: NotificationItem.PropsWithoutId[]) => {
  return (dispatch: Dispatch) => {
    notifications.forEach(notification => {
      if (notification.type === 'error') {
        // eslint-disable-next-line no-console
        console.error(`Show error notification: ${notification.content}`);
      }
    });

    dispatch({
      type: PageActionType.ADD_NOTIFICATIONS,
      payload: notifications,
    });
  };
};

export const addNotification = (notification: NotificationItem.PropsWithoutId) => addNotifications([notification]);

export const addGenericErrorNotification = (message: string, disallowDismiss?: boolean, shouldAutoRemove?: boolean) => {
  const notification: NotificationItem.PropsWithoutId = {
    type: 'error',
    iconType: 'error',
    content: message,
    shouldAutoRemove: !!shouldAutoRemove,
    disallowDismiss: !!disallowDismiss,
  };
  // eslint-disable-next-line no-console
  console.error(`Show generic error notification: ${message}`);
  return (dispatch: Dispatch) => {
    dispatch({
      type: PageActionType.ADD_NOTIFICATIONS,
      payload: [notification],
    });
  };
};

export const addApiErrorNotification = (message: string, exception: AxiosError<{ message?: string }>) => {
  const error = `${message} (${exception.response?.data?.message || exception.message})`;
  const notification: NotificationItem.PropsWithoutId = {
    type: 'error',
    iconType: 'error',
    content: error,
    shouldAutoRemove: true,
  };
  // eslint-disable-next-line no-console
  console.error(`Show error notification: ${error}`, exception);
  return (dispatch: Dispatch) => {
    dispatch({
      type: PageActionType.ADD_NOTIFICATIONS,
      payload: [notification],
    });
  };
};

export const removeNotification = (notificationId: string) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: PageActionType.REMOVE_NOTIFICATION,
      payload: notificationId,
    });
  };
};
